import React, { useEffect, useRef } from 'react';
import styled from 'styled-components';
import Typed from 'typed.js';

const Hero = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  text-align: center;

  img {
    max-width: 400px;
    animation: fadeIn 1.5s ease-in-out;
    margin-bottom: 0.5rem; /* Reduce the bottom margin here */
  }

  h1 {
    font-size: 4rem;
    color: #66b2b2;
    line-height: 1.2;
    margin: 0.5rem 0; /* Reduce the margin between h1 and the image */
    margin-top: -80px;

    @media (max-width: 768px) {
      font-size: 2.5rem;
    }
  }

  .typed-container {
    display: block;
    text-align: center;
    margin-top: 0.3rem; /* Adjust margin above typed text */
  }

  .typed-words {
    display: inline-block;
    font-weight: bold;
    color: #80c8c8;
    white-space: nowrap;

    .typed-cursor {
      font-size: 1em;
      color: #80c8c8;
      animation: blink 0.7s step-end infinite;
    }
  }

  p {
    font-size: 1.2rem;
    margin-bottom: 1.5rem;
    color: #7a7a7a;
    max-width: 750px;

    @media (max-width: 768px) {
      font-size: 1rem;
    }
  }

//   button {
//     background-color: #66b2b2;
//     color: white;
//     border: none;
//     padding: 1rem 2.5rem;
//     font-size: 1.2rem;
//     border-radius: 25px;
//     cursor: pointer;
//     position: relative;
//     overflow: hidden;
//     transition: transform 0.3s, background-color 0.3s;

//     &:hover {
//       transform: scale(1.05);
//       background-color: #80c8c8;
//     }

//     @media (max-width: 768px) {
//       padding: 0.8rem 2rem;
//       font-size: 1rem;
//     }
//   }

  @keyframes blink {
    50% {
      opacity: 0;
    }
  }
`;

const PrimaryButton = styled.button`
  background-color: transparent;
  color: #66b2b2;
  border: 2px solid #66b2b2;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s, background-color 0.3s, color 0.3s;

  &:hover {
    background-color: #66b2b2;
    color: white;
    transform: scale(1.05);
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  &:hover::after {
    left: 100%;
  }
`;

const SecondaryButton = styled.button`
  background-color: #66b2b2;
  color: white;
  border: none;
  padding: 0.8rem 1.5rem;
  font-size: 1rem;
  border-radius: 10px;
  cursor: pointer;
  position: relative;
  overflow: hidden;
  transition: transform 0.3s, background-color 0.3s;

  &:hover {
    transform: scale(1.05);
    background-color: #80c8c8;
  }

  &::after {
    content: "";
    position: absolute;
    top: 0;
    left: -100%;
    width: 200%;
    height: 100%;
    background: linear-gradient(90deg, transparent, rgba(255, 255, 255, 0.3), transparent);
    transition: left 0.5s;
  }

  &:hover::after {
    left: 100%;
  }
`;

const HeroComponent = () => {
  const typedElement = useRef(null);

  useEffect(() => {
    if (typedElement.current) {
      const typed = new Typed(typedElement.current, {
        strings: ['profiles', 'stories', 'photos', 'videos', 'milestones', 'updates'],
        typeSpeed: 150, // Slower typing
        backSpeed: 100, // Slower deletion
        loop: true,
        cursorChar: '|', // Custom cursor character
      });

      console.log('Typed.js initialized:', typed);

      // Cleanup to prevent memory leaks
      return () => typed.destroy();
    } else {
      console.error('Typed.js initialization failed: ref is null');
    }
  }, []);

  return (
    <Hero>
      <img src="assets/icon.png" alt="FurEverPixels Logo" />
      <h1>
        The place for Pet
        <div className="typed-container">
          <span className="typed-words" ref={typedElement}></span>
        </div>
      </h1>
      <p>
        Discover, celebrate, and share your pets with a community of animal
        lovers through our platform designed for connection and inspiration.
      </p>
      <div style={{ display: 'flex', gap: '1rem', justifyContent: 'center' }}>
        <SecondaryButton>Im Feeling Lucky</SecondaryButton>
        <PrimaryButton>Sign up</PrimaryButton>
      </div>
    </Hero>
  );
};

export default HeroComponent;
